import QueueManagement from "@/components/queue/QueueManagement";
import LocalEngagementTime from "@/components/queue/EngagementTime";

export default [
  {
    path: "/queue/queue-management",
    name: "QueueManagement",
    component: QueueManagement,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/queue/local-engagement-time",
    name: "LocalEngagementTime",
    component: LocalEngagementTime,
    meta: {
      requiresAuthentication: true
    }
  }
];
